
/* injects from baggage-loader */

angular.module('siter.io').controller('Lessons', [
  "$scope", "Restangular", "$modal", "$stateParams", "$state", 'Lesson', "$rootScope",
  ($scope, Restangular, $modal, $stateParams, $state, Lesson, $rootScope) => {

    $scope.state = $state;

    const _getLessonSuccess = (siteData) => {
      if (siteData.style_attributes) {
        siteData.style_attributes.maxWidth = parseInt(siteData.style_attributes.maxWidth);
      }
      return $rootScope.site = siteData;
    };

    const _getLessonFail = (response) => {
      return $state.go("404");
    };

    Lesson.get().then(_getLessonSuccess, _getLessonFail);

    return angular.element("body").on("keypress", "span[contenteditable]", (e) => {
      return e.which !== 13;
    });
  }
]);



// WEBPACK FOOTER //
// ./src/app/site/lesson.controller.js